const bayerm = [
  {
    id: 1,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2025",
      "2025 bayern",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/25-26-01/uni0.jpg",
      "/images/europa/bayerm/25-26-01/uni1.jpg",
      "/images/europa/bayerm/25-26-01/uni2.jpg",
      "/images/europa/bayerm/25-26-01/uni3.jpg",
      "/images/europa/bayerm/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2025",
      "2025 bayern",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/25-26-02/uni0.jpg",
      "/images/europa/bayerm/25-26-02/uni1.jpg",
      "/images/europa/bayerm/25-26-02/uni2.jpg",
      "/images/europa/bayerm/25-26-02/uni3.jpg",
      "/images/europa/bayerm/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2025",
      "2025 bayern",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/25-26-03/uni0.jpg",
      "/images/europa/bayerm/25-26-03/uni1.jpg",
      "/images/europa/bayerm/25-26-03/uni2.jpg",
      "/images/europa/bayerm/25-26-03/uni3.jpg",
      "/images/europa/bayerm/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 25/26 - Uniforme de Goleiro (Verde)",
    tipo: "masculino",
    aliases: [
      "bayer",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2025",
      "2025 bayern",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/25-26-05-gv/uni0.jpg",
      "/images/europa/bayerm/25-26-05-gv/uni1.jpg",
      "/images/europa/bayerm/25-26-05-gv/uni2.jpg",
      "/images/europa/bayerm/25-26-05-gv/uni3.jpg",
      "/images/europa/bayerm/25-26-05-gv/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2025",
      "2025 bayern",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/25-26-00-es/uni0.jpg",
      "/images/europa/bayerm/25-26-00-es/uni1.jpg",
      "/images/europa/bayerm/25-26-00-es/uni2.jpg",
      "/images/europa/bayerm/25-26-00-es/uni3.jpg",
      "/images/europa/bayerm/25-26-00-es/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2025",
      "2025 bayern",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/25-26-00-es2/uni0.jpg",
      "/images/europa/bayerm/25-26-00-es2/uni1.jpg",
      "/images/europa/bayerm/25-26-00-es2/uni2.jpg",
      "/images/europa/bayerm/25-26-00-es2/uni3.jpg",
      "/images/europa/bayerm/25-26-00-es2/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2024",
      "2024 bayern",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/24-25-01/uni0.jpg",
      "/images/europa/bayerm/24-25-01/uni1.jpg",
      "/images/europa/bayerm/24-25-01/uni2.jpg",
      "/images/europa/bayerm/24-25-01/uni3.jpg",
      "/images/europa/bayerm/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2024",
      "2024 bayern",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/24-25-02/uni0.jpg",
      "/images/europa/bayerm/24-25-02/uni1.jpg",
      "/images/europa/bayerm/24-25-02/uni2.jpg",
    ],
  },
  {
    id: 9,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 24/25 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2024",
      "2024 bayern",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/24-25-03/uni0.jpg",
      "/images/europa/bayerm/24-25-03/uni1.jpg",
      "/images/europa/bayerm/24-25-03/uni2.jpg",
      "/images/europa/bayerm/24-25-03/uni3.jpg",
      "/images/europa/bayerm/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 24/25 - Uniforme de Treino (Preta)",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2024",
      "2024 bayern",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/24-25-05-tp/uni0.jpg",
      "/images/europa/bayerm/24-25-05-tp/uni1.jpg",
      "/images/europa/bayerm/24-25-05-tp/uni2.jpg",
      "/images/europa/bayerm/24-25-05-tp/uni3.jpg",
      "/images/europa/bayerm/24-25-05-tp/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 24/25 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2024",
      "2024 bayern",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/24-25-00-es1/uni0.jpg",
      "/images/europa/bayerm/24-25-00-es1/uni1.jpg",
      "/images/europa/bayerm/24-25-00-es1/uni2.jpg",
      "/images/europa/bayerm/24-25-00-es1/uni3.jpg",
      "/images/europa/bayerm/24-25-00-es1/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 24/25 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2024",
      "2024 bayern",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/24-25-00-es/uni0.jpg",
      "/images/europa/bayerm/24-25-00-es/uni1.jpg",
      "/images/europa/bayerm/24-25-00-es/uni2.jpg",
      "/images/europa/bayerm/24-25-00-es/uni3.jpg",
      "/images/europa/bayerm/24-25-00-es/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 22/23 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2022",
      "2022 bayern",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/22-23-01/uni0.jpeg",
      "/images/europa/bayerm/22-23-01/uni1.jpeg",
      "/images/europa/bayerm/22-23-01/uni2.jpeg",
      "/images/europa/bayerm/22-23-01/uni3.jpeg",
      "/images/europa/bayerm/22-23-01/uni4.jpeg",
    ],
  },
  {
    id: 14,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 21/22 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2021",
      "2021 bayern",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/21-22-01/uni0.jpg",
      "/images/europa/bayerm/21-22-01/uni1.jpg",
      "/images/europa/bayerm/21-22-01/uni2.jpg",
      "/images/europa/bayerm/21-22-01/uni3.jpg",
      "/images/europa/bayerm/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 21/22 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2021",
      "2021 bayern",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/21-22-02/uni0.jpg",
      "/images/europa/bayerm/21-22-02/uni1.jpg",
      "/images/europa/bayerm/21-22-02/uni2.jpg",
      "/images/europa/bayerm/21-22-02/uni3.jpg",
      "/images/europa/bayerm/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 21/22 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2021",
      "2021 bayern",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/21-22-03/uni0.png",
      "/images/europa/bayerm/21-22-03/uni1.png",
      "/images/europa/bayerm/21-22-03/uni2.png",
      "/images/europa/bayerm/21-22-03/uni3.png",
      "/images/europa/bayerm/21-22-03/uni4.png",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 20/21 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2020",
      "2020 bayern",
      "2020",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/20-21-02/uni0.jpg",
      "/images/europa/bayerm/20-21-02/uni1.jpg",
      "/images/europa/bayerm/20-21-02/uni2.jpg",
      "/images/europa/bayerm/20-21-02/uni3.jpg",
      "/images/europa/bayerm/20-21-02/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 20/21 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2020",
      "2020 bayern",
      "2020",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/20-21-03/uni0.jpg",
      "/images/europa/bayerm/20-21-03/uni1.jpg",
      "/images/europa/bayerm/20-21-03/uni2.jpg",
      "/images/europa/bayerm/20-21-03/uni3.jpg",
      "/images/europa/bayerm/20-21-03/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 14/15 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2014",
      "2014 bayern",
      "2014",
      "bayern retro",
      "retro bayern",
      "retro bayern de munique retro",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/14-15-01-rt/uni0.jpg",
      "/images/europa/bayerm/14-15-01-rt/uni1.jpg",
      "/images/europa/bayerm/14-15-01-rt/uni2.jpg",
      "/images/europa/bayerm/14-15-01-rt/uni3.jpg",
      "/images/europa/bayerm/14-15-01-rt/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 07/08 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2007",
      "2007 bayern",
      "2007",
      "bayern retro",
      "retro bayern",
      "retro bayern de munique retro",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/07-08-01-rt/uni0.jpg",
      "/images/europa/bayerm/07-08-01-rt/uni1.jpg",
      "/images/europa/bayerm/07-08-01-rt/uni2.jpg",
      "/images/europa/bayerm/07-08-01-rt/uni3.jpg",
      "/images/europa/bayerm/07-08-01-rt/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 05/06 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2005",
      "2005 bayern",
      "2005",
      "bayern retro",
      "retro bayern",
      "retro bayern de munique retro",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/05-06-01-rt/uni0.jpg",
      "/images/europa/bayerm/05-06-01-rt/uni1.jpg",
      "/images/europa/bayerm/05-06-01-rt/uni2.jpg",
      "/images/europa/bayerm/05-06-01-rt/uni3.jpg",
      "/images/europa/bayerm/05-06-01-rt/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 00/01 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2000",
      "2000 bayern",
      "2000",
      "bayern retro",
      "retro bayern",
      "retro bayern de munique retro",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/00-01-01-rt/uni0.jpg",
      "/images/europa/bayerm/00-01-01-rt/uni1.jpg",
      "/images/europa/bayerm/00-01-01-rt/uni2.jpg",
      "/images/europa/bayerm/00-01-01-rt/uni3.jpg",
      "/images/europa/bayerm/00-01-01-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 00/01 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 2000",
      "2000 bayern",
      "2000",
      "bayern retro",
      "retro bayern",
      "retro bayern de munique retro",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/00-01-02-rt/uni0.jpg",
      "/images/europa/bayerm/00-01-02-rt/uni1.jpg",
      "/images/europa/bayerm/00-01-02-rt/uni2.jpg",
      "/images/europa/bayerm/00-01-02-rt/uni3.jpg",
      "/images/europa/bayerm/00-01-02-rt/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 98/99 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 1998",
      "1998 bayern",
      "1998",
      "bayern retro",
      "retro bayern",
      "retro bayern de munique retro",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/98-99-01-rt/uni0.jpg",
      "/images/europa/bayerm/98-99-01-rt/uni1.jpg",
      "/images/europa/bayerm/98-99-01-rt/uni2.jpg",
      "/images/europa/bayerm/98-99-01-rt/uni3.jpg",
      "/images/europa/bayerm/98-99-01-rt/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 97/98 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 1997",
      "1997 bayern",
      "1997",
      "bayern retro",
      "retro bayern",
      "retro bayern de munique retro",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/97-98-01/uni0.jpg",
      "/images/europa/bayerm/97-98-01/uni1.jpg",
      "/images/europa/bayerm/97-98-01/uni2.jpg",
      "/images/europa/bayerm/97-98-01/uni3.jpg",
      "/images/europa/bayerm/97-98-01/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 95/96 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 1995",
      "1995 bayern",
      "1995",
      "bayern retro",
      "retro bayern",
      "retro bayern de munique retro",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/95-96-01-rt/uni0.jpg",
      "/images/europa/bayerm/95-96-01-rt/uni1.jpg",
      "/images/europa/bayerm/95-96-01-rt/uni2.jpg",
      "/images/europa/bayerm/95-96-01-rt/uni3.jpg",
      "/images/europa/bayerm/95-96-01-rt/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 95/96 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 1995",
      "1995 bayern",
      "1995",
      "bayern retro",
      "retro bayern",
      "retro bayern de munique retro",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/95-96-02-rt/uni0.jpg",
      "/images/europa/bayerm/95-96-02-rt/uni1.jpg",
      "/images/europa/bayerm/95-96-02-rt/uni2.jpg",
      "/images/europa/bayerm/95-96-02-rt/uni3.jpg",
      "/images/europa/bayerm/95-96-02-rt/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique 93/94 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern 1993",
      "1993 bayern",
      "1993",
      "bayern retro",
      "retro bayern",
      "retro bayern de munique retro",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/bayerm/93-94-02-rt/uni0.jpg",
      "/images/europa/bayerm/93-94-02-rt/uni1.jpg",
      "/images/europa/bayerm/93-94-02-rt/uni2.jpg",
      "/images/europa/bayerm/93-94-02-rt/uni3.jpg",
      "/images/europa/bayerm/93-94-02-rt/uni4.jpg",
    ],
  },
  {
    id: 28,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique - Jaqueta (Cinza)",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern jaqueta",
      "jaqueta bayern",
      "jaqueta bayern de munique jaqueta",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/jc/uni0.jpg",
      "/images/europa/bayerm/jc/uni1.jpg",
      "/images/europa/bayerm/jc/uni2.jpg",
      "/images/europa/bayerm/jc/uni3.jpg",
      "/images/europa/bayerm/jc/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "europa",
    liga: "bundesliga",
    time: "bayern-de-munique",
    nome: "Bayern de Munique - Jaqueta (Vermelha)",
    tipo: "masculino",
    aliases: [
      "bayern",
      "bavaros ",
      "bayern de munique",
      "munique",
      "bayern jaqueta",
      "jaqueta bayern",
      "jaqueta bayern de munique jaqueta",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/bayerm/jv/uni0.png",
      "/images/europa/bayerm/jv/uni1.jpg",
      "/images/europa/bayerm/jv/uni2.jpg",
      "/images/europa/bayerm/jv/uni3.jpg",
      "/images/europa/bayerm/jv/uni4.jpg",
    ],
  },
];

export default bayerm;
